import { Link } from 'react-router-dom';
import { type PanelSpan } from '@/components/shared';
import { formatShortId } from '../format';
import type { BackofficeProjectAccessUser } from '../types';
import { ProjectDetailPanel } from './ProjectDetailPanelGrid';

export interface ProjectAccessPanelProps {
  accessUsers: BackofficeProjectAccessUser[];
  panelId?: string | undefined;
  currentSpan?: PanelSpan | undefined;
}

function getUserDisplayName(user: BackofficeProjectAccessUser): string {
  return user.name ?? user.email ?? formatShortId(user.id);
}

export function ProjectAccessPanel({ accessUsers, panelId, currentSpan }: ProjectAccessPanelProps) {
  return (
    <ProjectDetailPanel
      title="Study access"
      span="2x2"
      panelId={panelId}
      currentSpan={currentSpan}
      contentClassName="mt-2"
    >
      {accessUsers.length > 0 ? (
        <ul className="divide-y divide-neutral-100">
          {accessUsers.map((user) => {
            const displayName = getUserDisplayName(user);
            const showEmail = Boolean(user.email && user.email !== displayName);

            return (
              <li key={user.id}>
                <Link
                  to={`/users/${user.id}`}
                  className="focus-ring -mx-2 flex items-center justify-between gap-4 rounded-md px-2 py-3 hover:bg-backoffice-50"
                >
                  <span className="min-w-0">
                    <span className="block truncate font-medium text-neutral-900">
                      {displayName}
                    </span>
                    {showEmail ? (
                      <span className="block truncate text-small text-neutral-500">
                        {user.email}
                      </span>
                    ) : null}
                  </span>
                  <span className="shrink-0 rounded-full bg-neutral-100 px-2.5 py-1 text-small font-medium text-neutral-700">
                    {user.roleLabel}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="text-body text-neutral-500">No people found</p>
      )}
    </ProjectDetailPanel>
  );
}
